import Bus from '@/utils/bus'; // 中央事件总线
import { auctionList, auctionInfo, statusNum, auctionCallOff } from "@/api/onlinetaking"; // 拍单请求
import { drugList } from "@/api/drug"; // 药品请求
import { patientInfo } from "@/api/patient"; // 患者请求
import { addressList, deliveryMethod } from "@/api/address"; // 获取配送请求
import { deliveryPrice } from "@/api/delivery"; // 获取配送请求
import { processingPrice } from "@/api/processing"; // 获取加工请求
import { drugPaymentDetailByAuctionId } from "@/api/drugpayment"; // 中药处方划价请求
import { comboPaymentDetailByAuctionId } from "@/api/combopayment"; // 隐秘处方划价请求
import TakingEdit from './TakingEdit/index.vue'; // 引入拍单划价弹框
export default {
  name: 'OnlineTaking',
  components: { TakingEdit },
  data() {
    return {
      loading: true, // 加载中
      searchForm: { consigneeName: null, phone: null, createTime: null, status: 0, paymentStatus: null }, // 查询表单
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      orderList: [], // 订单列表
      activeIndex: '1', // 默认激活菜单
      menuList: [
        { label: '全部订单', name: 'status', value: null, number: 0, paramName: 'all' },
        { label: '待处理', name: 'status', value: 0, number: 0, paramName: 'pending' },
        { label: '待支付', name: 'paymentStatus', value: 0, number: 0, paramName: 'stayPay' },
        { label: '订单已生成', name: 'paymentStatus', value: 2, number: 0, paramName: 'generateSuccess' },
        { label: '正在审方', name: 'paymentStatus', value: 3, number: 0, paramName: 'audit' },
        { label: '正在配方', name: 'paymentStatus', value: 4, number: 0, paramName: 'recipe' },
        { label: '正在复审', name: 'paymentStatus', value: 5, number: 0, paramName: 'recheck' },
        { label: '正在加工', name: 'paymentStatus', value: 6, number: 0, paramName: 'processing' },
        { label: '正在打包', name: 'paymentStatus', value: 7, number: 0, paramName: 'packaging' },
        { label: '正在配送', name: 'paymentStatus', value: 8, number: 0, paramName: 'delivery' },
        { label: '快递送达', name: 'paymentStatus', value: 9, number: 0, paramName: 'goodsArrive' },
        { label: '订单完成', name: 'paymentStatus', value: 10, number: 0, paramName: 'complete' },
        { label: '已取消订单', name: 'status', value: -1, number: 0, paramName: 'auctionCancel' },
        { label: '识别失败', name: 'status', value: 2, number: 0, paramName: 'notPass' },
        { label: '快递退回', name: 'paymentStatus', value: -3, number: 0, paramName: 'deliveryBack' },
        { label: '已退款', name: 'paymentStatus', value: -2, number: 0, paramName: 'refund' },
        { label: '已作废', name: 'paymentStatus', value: -1, number: 0, paramName: 'paymentCancel' },
        { label: '已跑单', name: 'paymentStatus', value: -4, number: 0, paramName: 'single' }
      ],
      dialogVisible: false, // 模态框状态
      dialogForm: {}, // 当前选择订单详情
      recipeData: {}, // 电子处方对象详情
      orderDelivery: {}, // 配送对象
      hospPatientInfo: {}, // 患者实体
      pickerOptions:{ // 日期不可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      deptId: this.$session.get('deptId'), // 医馆id
      tableHeight: 0, // 表格最大高度
      refreshTimer: null, // 刷新定时器
      addressList: [], // 地址列表
    }
  },
  created() {
    if (document.documentElement.clientWidth > 1290) this.tableHeight = document.documentElement.clientHeight - 310;
    else this.tableHeight = document.documentElement.clientHeight - 350;
    this.getOrderList(); // 获取拍单订单列表
    this.getStatusNumber(); // 获取订单各状态数量
    // this.refreshTimer = setInterval(() => { // 定时刷新订单
    //   this.getOrderList();
    //   this.getStatusNumber();
    // }, 5000);
  },
  destroyed() {
    clearInterval(this.refreshTimer);
  },
  watch: {
    // 监听searchForm.status变化，如果status==0，定时刷新，否则 不刷新
    'searchForm.status': {
      handler(newVal, oldVal) {
        if (newVal == 0) {
          this.refreshTimer = setInterval(() => { // 定时刷新订单
            this.getOrderList();
            this.getStatusNumber();
          }, 5000);
        } else clearInterval(this.refreshTimer);
      }
    }
  },
  methods: {
    // 获取地址列表
    async getAddressList(patientId = this.hospPatientInfo.patientId) {
      let {code, rows} = await addressList(patientId);
      if (code == 200) {
        this.addressList = rows;
        if (this.dialogForm.isDelivery == 1) {
          this.dialogForm.orderDelivery=rows[0]
          if (this.dialogForm.deliveryMemberId == null || this.dialogForm.deliveryMemberId == undefined) {
            
          }
        }
      }
    },
    // 获取拍单列表
    async getOrderList() {
      let {code, rows, total} = await auctionList({ pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
      if (code == 200) {
        this.total = total;
        rows.forEach(item => {
          this.judgeStatus(item); // 判断状态
          this.judgeDept(item); // 判断医馆
          item.types = item.imgAddr ? '图片处方' : '电子处方'; // 判断续方类型
          switch (item.paymentType) { // 判断处方类型
            case '0': item.paymentTypes = '中药处方'; break;
            case '1': item.paymentTypes = '隐秘处方'; break;
            case null: item.paymentTypes = '未知'; break;
          }
          item.isProcessing == '0' ? item.processingWay = '不加工' : item.processingWay; // 判断是否加工
          item.consigneeName == null ? item.consigneeName = item.patientName : item.consigneeName; // 判断取件人信息
          if (item.provinceName) {
            item.address = item.provinceName + ' ' + item.cityName + ' ' + item.regionName + ' ' + (item.scopeName || '') + ' ' + item.detailedAddress;
            item.address = item.address.length > 15 ? item.address.substr(0,15) + '...' : item.address;
          } else item.address = '- - - - -';
          // 判断参数是否为空
          for (let key in item) {
            if (!item[key]) item[key] = '-';
          }
        });
        this.orderList = rows;
        Bus.$emit('newOrderNumBack', 0);
        this.$session.set('newOrderNum', 0);
      }
      this.loading = false;
    },
    // 获取订单状态数量
    async getStatusNumber() {
      let search = this.searchForm;
      let { code, data } = await statusNum({
        consigneeName: search.consigneeName, phone: search.phone, status: search.status,
        createTime: search.createTime, paymentStatus: search.paymentStatus
      });
      if (code == 200) {
        this.menuList.forEach(item => {
          for (let key in data) {
            if (item.paramName == key) item.number = data[key]
          }
        })
      }
    },
    // 切换激活菜单
    handleSelect() {
      this.menuList.forEach((item, i) => {
        if (i == this.activeIndex) {
          if (item.name == 'status') {
            this.searchForm.status = item.value;
            this.searchForm.paymentStatus = null;
          } else {
            this.searchForm.paymentStatus = item.value;
            this.searchForm.status = 1;
          }
        }
      })
      this.$refresh(this.getOrderList, this.searchForm);
    },
    // 拍单划价
    async examine(auctionId, btnType) {
      let {code, data} = await auctionInfo(auctionId);
      if (code == 200) {
        this.judgeDept(data); // 判断医馆
        this.getPatientInfo(data.patientId); // 获取患者详情
        data.imgAddr ? data.types = '图片处方' : data.types = '电子处方'; // 判断处方类型
        if (btnType == 'view') this.getPricingData(auctionId, data); // 已划价获取详情回填
        else this.handleData(data); // 未划价处理数据
      }
    },
    // 获取划价数据
    async getPricingData(auctionId, obj) {
      if (obj.paymentType == 0 || obj.paymentType == null) {
        let {code, data} = await drugPaymentDetailByAuctionId(auctionId);
        if (code == 200 && data != null) {
          let { 
            recipeDrugItem, drugAmount, doctorId, weight, processingPrice, drugPrice, deliveryPrice,
            ingredientsPrice, filterPrice, totalPrice, discount, discountType, realPay,orderDelivery
          } = data;
          // 处方参数赋值
          this.recipeData = { recipeDrugItem, drugAmount, weight, doctorId };
          // 处理金额参数
          obj = {
            ...obj, processingPrice, drugPrice, deliveryPrice, realPay,
            filterPrice, totalPrice, discount, discountType, ingredientsPrice,orderDelivery
          }
          // 配送参数处理
          handleDelivery(data, this);
        }
      } else if (obj.paymentType == 1) {
        let {code, data} = await comboPaymentDetailByAuctionId(auctionId);
        if (code == 200 && data != null) {
          let { 
            comboItems, doctorId, weight, comboPrice, comboUnitPrice, doseNumber,
            deliveryPrice, totalPrice, discount, comboName, discountType, realPay
          } = data;
          // 处方参数赋值
          this.recipeData = { comboItems, doseNumber, weight, doctorId, comboName };
          // 处理金额参数
          obj = {
            ...obj, comboPrice, comboUnitPrice, deliveryPrice,
            totalPrice, discount, discountType, realPay
          }
          // 配送参数处理
          handleDelivery(data, this);
        }
      }
      // 配送参数处理
      function handleDelivery(data, _this) {
        if (data.orderDelivery != null) {
          let {
            cityId, companyName, scopeId, consigneeName,
            detailedAddress, phone, provinceId, regionId
          } = data.orderDelivery;
          _this.dialogForm.orderDelivery = {
            cityId, companyName, scopeId, consigneeName,
            detailedAddress, phone, provinceId, regionId
          };
         _this.dialogForm.companyName=companyName;
        };
      }
      this.dialogForm = {...this.dialogForm,...obj};
      if(this.dialogForm.isDelivery=='1')  this.getDeliveryPrice(this.dialogForm)
      this.dialogVisible = true;
    },
    // 处理划价数据
    async handleData(obj) {
      // 设置基础信息
      obj.patientRemark = obj.remark;
      obj.discountType = '0';
      obj.takingDosage='每次50ml'
      obj.discount = 100;
      obj.recipeDrugIngredient = [];
      obj.drugPrice = 0, obj.costPrice = 0, obj.filterPrice = 0, obj.processingPrice = 0, obj.realPay = 0;
      obj.ingredientsPrice = 0, obj.totalPrice = 0, obj.deliveryPrice = 0, obj.totalPrice = 0;
      obj.bagNumberSum = obj.bagNumber * obj.doseNumber;
      // 设置处方信息
      this.recipeData = { recipeDrugItem: [], drugAmount: 0, weight: 0, doctorId: null };
      // 计算过滤袋费
      if (obj.drugNumber > 0) {
        drugList({specifications: '3号AC<300*240>'}).then(res => {
          let {code, rows} = res;
          if (code == 200) {
            obj.filterDrugArtNo=rows[0].id
            obj.filterPrice = this.$bigNumber(obj.drugNumber, '*', rows[0].price);
            obj.realPay = this.$bigNumber(obj.realPay,'+',rows[0].price);
            obj.totalPrice = this.$bigNumber(obj.totalPrice,'+',rows[0].price);
          }
        });
      }
      this.getAddressList(obj.patientId); // 获取地址列表
      // 配送相关
      if (obj.isDelivery == '1') {
        let {
          cityName, cityId, deliveryWay, consigneeName, detailedAddress, phone,
          provinceName, provinceId, regionName, regionId, scopeName, scopeId
        } = obj;
        // 处理配送实体
        obj.orderDelivery = {
          cityName, cityId, companyName: deliveryWay, consigneeName, detailedAddress, phone, price: 0,
          province: provinceName, provinceId, region: regionName, regionId, scopeId, scopeName
        }
        let timer = setTimeout(() => {
          clearTimeout(timer);
          this.addressList.forEach(item => {
            if (
              item.cityId == cityId && item.regionId == regionId
              && item.provinceId == provinceId && item.scopeId == scopeId
              && item.detailedAddress == detailedAddress
              && item.consigneeName == consigneeName
              && item.phone == phone
            ) obj.deliveryMemberId = item.deliveryMemberId;
          });
          obj.companyName = deliveryWay;
          let params = { cityId, provinceId, scopeId, regionId };
          // 获取可选配送方式
          deliveryMethod(params).then(res => {
            obj.deliveryOptions = JSON.parse(JSON.stringify(this.$otherDeliveryWay));
            res.data.forEach(item => { obj.deliveryOptions.unshift(item.companyName) });
            this.getDeliveryPrice(obj);
          });
        }, 500);
      } else {
        obj.deliveryPrice = '0';
        obj.orderDelivery = { consigneeName: obj.patientName, phone: obj.phone }
        obj.deliveryPrice = 0;
        this.computeTotalPrice(obj);
      }
      for (let key in obj) {
        if (key.indexOf('rice') != '-1') obj[key] = Math.round(obj[key] * 100) / 100; 
      }
      this.dialogForm = obj;
      this.dialogVisible = true;
    },
    // 获取加工费
    getProcessingPrice(obj) {
      if (obj.isProcessing == '1') {
        obj.bagNumberSum = this.$bigNumber(obj.bagNumber, '*', obj.doseNumber);
        let { bagNumber, bagNumberSum, doseNumber, processingWay} = obj;
        let params = { bagNumber, bagNumberSum, number: doseNumber, processingType: processingWay, weight: this.recipeData.weight };
        processingPrice(params).then(res => {
          let {code, data} = res;
          if (code == 200) {
            obj.processingPrice = data || 0;
            this.computeTotalPrice(obj);
          }
        });
      } else {
        obj.processingPrice = 0;
        this.computeTotalPrice(obj);
      }
    },
    // 获取配送费
    getDeliveryPrice(obj) {
      if (this.dialogForm.companyName && obj.orderDelivery) {
        let { cityId, regionId, provinceId, scopeId } = obj.orderDelivery;
        let { doseNumber, drugPrice, companyName } = this.dialogForm;
        let params = {
          cityId, scopeId, companyName, provinceId, doseNumber,
          regionId, weight: this.recipeData.weight, drugPrice: drugPrice || 0
        }
        if (companyName == '顺丰快递' || companyName == '同城快递') {
          deliveryPrice(params).then(res => {
            let {code, data} = res;
            if (code == 200) {
              this.dialogForm.deliveryPrice = data;
              this.dialogForm.orderDelivery.price = data;
              this.$forceUpdate();
              this.computeTotalPrice(this.dialogForm);
            }
          });
        }
      } else this.computeTotalPrice(this.dialogForm);
    },
    // 计算拍单总价及实付
    computeTotalPrice(obj) {
      let { drugPrice, filterPrice, processingPrice, deliveryPrice, ingredientsPrice, discount } = obj;
      this.$forceUpdate(); // 强制更新视图
      // obj.totalPrice = Number(drugPrice) + Number(filterPrice) + Number(processingPrice) + Number(deliveryPrice) + Number(ingredientsPrice);
      obj.totalPrice = this.$bigNumber(this.$bigNumber(this.$bigNumber(this.$bigNumber(drugPrice, '+', filterPrice), '+', processingPrice), '+', deliveryPrice), '+', ingredientsPrice);
      if (obj.discountType == '0') obj.realPay =this.$bigNumber(this.$bigNumber( obj.totalPrice, '*', discount), '/', 100); // 整单打折
      // else obj.realPay = (drugPrice * discount / 100) + (obj.totalPrice - drugPrice); // 药费打折
      else obj.realPay = this.$bigNumber((this.$bigNumber(this.$bigNumber(drugPrice, '*', discount), '/', 100)), '+', (this.$bigNumber(obj.totalPrice, '-', drugPrice))); // 药费打折
      // obj.realPay = Math.round(obj.realPay * 100) / 100;
      obj.realPay = this.$bigNumber(this.$bigNumber(obj.realPay, '*', 100),'/',100,2);
      this.$forceUpdate();
    },
    // 取消拍单
    async cancelAuction(auctionId) {
      let { code } = await auctionCallOff(auctionId);
      if (code == 200) {
        this.$message.success('取消拍单成功！');
        this.$refresh([this.getOrderList, this.getStatusNumber]);
      }
    },
    // 判断状态
    judgeStatus(obj) {
      switch(obj.status) {
        case '-1': obj.statusStr = '订单已取消'; break;
        case '0': obj.statusStr = '订单待处理'; break;
        case '1': {
          switch(obj.paymentStatus) {
            case "-3": obj.statusStr = "快递退回"; break;
            case "-2": obj.statusStr = "订单已退款"; break;
            case '-1': obj.statusStr = "订单已作废"; break;
            case "0": obj.statusStr = "订单待支付"; break;
            case "2": obj.statusStr = "订单已支付"; break;
            case "3": obj.statusStr = "正在审方"; break;
            case "4": obj.statusStr = "正在配方"; break;
            case "5": obj.statusStr = "正在复审"; break;
            case "6": obj.statusStr = "正在加工"; break;
            case "7": obj.statusStr = "正在打包"; break;
            case "8": obj.statusStr = "正在配送"; break;
            case "9": obj.statusStr = "快递已送达"; break;
            case "10": obj.statusStr = "订单已完成"; break;
          }
        }; break;
        case '2': obj.statusStr = '订单识别失败'; break;
      }
    },
    // 判断医馆
    judgeDept(obj) {
      this.$session.get('options').forEach(item => { 
        if (item.value == obj.deptId) obj.deptName = item.label;
      });
    },
    // 获取患者信息
    getPatientInfo(patientId) {
      patientInfo(patientId).then(res => {
        let {code, data} = res;
        if (code == 200) {
          data.sexs = data.sex == '0' ? '男' : '女';
          this.$computeAge(data.birthday, data);
          this.hospPatientInfo = data;
        }
      });
    },
    dialogFormBack(val) { this.dialogVisible = val },
    orderDeliveryBack(val) { this.dialogForm.orderDelivery = val }
  }
}